// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"360":"5d54992c","408":"e5f6b31f","657":"52fedaef","837":"9cfa4896","928":"b5376c58"}[chunkId] + ".js";
};